import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SessionService} from '../../services/session/session.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {SnackBarComponent} from '../snackbar/snackbar.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { TabStorageService } from '../../services/tabstorage/tabstorage.service';

@Component({
    selector: 'app-token',
    templateUrl: './token.page.html',
    styleUrls: ['./token.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TokenComponent implements OnInit {

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private sessionService: SessionService,
      private spinner: SpinnerService,
      private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.spinner.show('Loading...');
    const handoffCode = this.route.snapshot.queryParamMap.get('code');
    if (handoffCode) {
      void this.consumeHandoff(handoffCode);
      return;
    }
    this.route.params.subscribe(async (params: Params): Promise<void> => {
      try {
        TabStorageService.clearCurrentTabSession();
        this.sessionService.setToken(params.token, params.refresh);
        this.sessionService.createTeam = 'create' in params;
        await this.sessionService.getRefreshTokenCognito();
        await this.navigateAfterHandoff(this.route.snapshot.queryParamMap.get('teamId'));
        this.spinner.hide();
      } catch (error) {
        this.spinner.hide();
        this.snackBar.openFromComponent(SnackBarComponent, {data: 'An error occurred while being redirected'});
        console.error('Legacy token handoff failed', 'invalid-session-or-navigation');
        this.sessionService.logout();
      }
    });
  }

  private navigateAfterHandoff(teamId: string | null): Promise<boolean> {
    return this.router.navigate(teamId && !this.sessionService.createTeam
      ? ['/managewellspace/overview', teamId]
      : ['']);
  }

  private async consumeHandoff(handoffCode: string): Promise<void> {
    try {
      const teamId = this.route.snapshot.queryParamMap.get('teamId');
      const createParam = this.route.snapshot.queryParamMap.get('create');
      const createTeam = createParam === '1' || createParam === 'true';
      await this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true,
      });
      TabStorageService.clearCurrentTabSession();
      const session = await this.sessionService.consumeHandoff(handoffCode);
      if (!session?.id || !session?.refreshToken) {
        throw new Error('Invalid handoff session');
      }
      this.sessionService.setToken(session.id, session.refreshToken);
      this.sessionService.createTeam = createTeam;
      await this.sessionService.getRefreshTokenCognito();
      await this.navigateAfterHandoff(teamId);
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      this.snackBar.openFromComponent(SnackBarComponent, {data: 'This sign-in link is invalid or expired'});
      console.error('Opaque token handoff failed', 'exchange-or-navigation-failed');
      this.sessionService.logout();
      await this.router.navigate(['/login'], {replaceUrl: true});
    }
  }

}
